<template>
  <div
    class="p-2 bg-white rounded-md !shadow-lg cursor-pointer"
    :class="{ 'ring-2 ring-gray-900': selected }"
    @click="clickEvent"
  >
    <div class="flex gap-6 flex-col md:flex-row" @click="onClickSelected">
      <div
        class="bg-gray-100 rounded-md p-2 md:w-3/5 relative"
        :class="{ grow: caller == 'SuggestedStudentForm' }"
      >
        <div class="flex flex-row gap-4">
          <div class="flex gap-2 md:w-1/3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="m-1 h-6 w-6"
              fill="rgb(241, 111, 66)"
              viewBox="0 0 24 24"
              stroke="rgb(241, 111, 66)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <div style="font-size: 15px; font-weight: bold;">
              {{
                `${item.firstName}${item.middleName ? ` ${item.middleName}` : ''} ${item.lastName}`
              }}
            </div>
          </div>
        </div>

        <div v-if="showOperationsInfoDisplay">
          <operations-info-display
            :item="item"
            :showDistrictConsortiumColumn="showConsortium"
            :showPartitionName="showPartitionName"
          />
        </div>
        <div v-else>
          <info-display
            :item="item"
            :showDistrictConsortiumColumn="showConsortium"
          />
        </div>

        <div v-if="existsPendingRequests" class="mt-1 absolute top-2 right-2">
          <div  class="absolute top-2 right-2">
            <div class="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 91.8 92.6"
                class="h-6 w-6 cursor-pointer"
                fill="rgb(241, 111, 66)" 
                @mouseover="hover = true"
                @mouseleave="hover = false"
              >
                <circle
                  cx="45.9" cy="46.3" r="42"
                  fill="rgb(241, 111, 66)"
                  stroke="#1E1E1E" stroke-width="2"
                />
                <path
                  d="M43.7,21.1h4.3c0.5,0,0.9,0.4,0.9,0.9l-0.6,34.5c0,0.5-0.4,0.9-0.9,0.9h-3c-0.5,0-0.9-0.4-0.9-0.9L42.8,22
                  C42.8,21.5,43.2,21.1,43.7,21.1z"
                  fill="black"
                  stroke-width="1.5"
                />
                <path
                  d="M48.6,71.2c-0.8,0.8-1.7,1.1-2.7,1.1c-1,0-1.9-0.3-2.6-1c-0.8-0.7-1.3-1.8-1.3-2.9
                  c0-1,0.4-1.9,1.1-2.7c0.7-0.8,1.8-1.2,2.9-1.2c1.2,0,2.2,0.5,3,1.4c0.5,0.6,0.8,1.3,0.9,2.1C49.9,69.3,49.5,70.3,48.6,71.2z"
                  fill="black"
                />
              </svg>
              <span
                v-show="hover"
                class="absolute text-sky-600 text-sm bg-white rounded-md shadow-md p-1 transition-opacity duration-300"
                style="top: -10px; left: 40px; white-space: nowrap; display: inline-block;"
              >
                This student has an upcoming change in their schedule.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-grow flex items-center" v-if="caller == 'StudentList'">
        <div class="grid grid-cols-5 gap-4 flex-grow">
          <div
            class="grid grid-rows-4 place-items-center"
            v-for="(weekday, index) in weekdays"
            :key="`direction-${index}`"
          >
            <div class="flex justify-center text-base py-1"></div>
            <div class="flex justify-center row-span-2">
              <div
                class="bg-gray-300 rounded-full h-10 w-10 flex items-center justify-center"
              >
                <div
                  class="rounded-full h-9 w-9 flex items-center justify-center text-white"
                  :style="{ background: directionGradient(item.schedule[weekday.name]) }"
                >
                  <div class="font-bold text-base">{{ weekday.text }}</div>
                </div>
              </div>
            </div>
            <div class="flex justify-center text-base py-1">
              {{ directions[item.schedule[weekday.name]] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="open" class="bg-gray-100 rounded-md p-2 mt-3">
      <StudentDetail :inputData="details" />
    </div>
    <div
      class="flex flex-row rounded-md bg-gray-100 mt-2 hover:bg-gray-200"
      v-if="open"
      @click="onClickExpand"
    >
      <AccordionIcon class="flex-none" :openDirectionDown="true" :open="open" />
      <div class="grow flex items-center justify-center">
        <span class="text-gray-500 font-italic text-xs">collapse</span>
      </div>
      <AccordionIcon class="flex-none" :openDirectionDown="true" :open="open" />
    </div>
  </div>
</template>

<script>
import StudentDetail from '../StudentDetail.vue'
import AccordionIcon from '../AccordionIcon.vue'

import InfoDisplay from './InfoDisplay/default.vue'
import OperationsInfoDisplay from './InfoDisplay/operations.vue'

import { getStudentDetail } from '../../services/api.js'

export default {
  components: {
    AccordionIcon,
    StudentDetail,
    InfoDisplay,
    OperationsInfoDisplay,
  },
  props: {
    item: Object,
    caller: String,
    selected: Boolean,
    showOperationsInfoDisplay: Boolean,
    showPartitionName: Boolean,
    existsPendingRequests: Boolean,
  },
  data() {
    return {
      open: false,
      details: {},
      weekdays: [
        {
          name: 'mon',
          text: 'M',
        },
        {
          name: 'tue',
          text: 'T',
        },
        {
          name: 'wed',
          text: 'W',
        },
        {
          name: 'thu',
          text: 'R',
        },
        {
          name: 'fri',
          text: 'F',
        },
      ],
      directions: {
        I: 'Inbound',
        O: 'Outbound',
        B: 'INB/OUTB',
      },
      hover: false,
    }
  },
  methods: {
    directionGradient(direction) {
      switch (direction) {
        case 'I':
          return 'linear-gradient(to right, rgba(0, 128, 212, 0.6) 50%, rgb(151, 153, 156) 50%)';
        case 'O':
          return 'linear-gradient(to right, rgb(151, 153, 156) 50%, rgba(0, 128, 212, 0.6) 50%)';
        case 'B':
          return 'rgba(0, 128, 212, 0.6)';
        default:
          return 'rgb(151, 153, 156)';
      }
    },
    async getStudentDetailData() {
      return (await getStudentDetail(this.item.dbId, { select: 'studentInfo' })).data
    },
    async toggleDetails() {
      if (!this.open) {
        this.details = await this.getStudentDetailData()
      }
      this.open = !this.open
    },
    clickEvent() {
      this.$emit('onPartitionSelected', this.item.partitionId)
    },
    onClickSelected() {
      this.$emit('changeSelected', this.item.dbId)

      if (this.caller == 'StudentList') {
        this.toggleDetails()
      }
    },
    onClickExpand() {
      if (this.caller == 'StudentList') {
        if (this.open) {
          setTimeout(this.toggleDetails, 0)
        }
      }
    },
  },
  computed: {
    showConsortium() {
      return this.item.district === 'MN-0000NW' || this.item.district === 'MN-000BIA'
    },
  },
  watch: {
    selected: async function () {
      if (!this.selected) {
        this.open = false
      }
    },
  },
  async created() {
    if (this.selected) {
      this.toggleDetails()
    }
  },
}
</script>